module.exports = __webpack_public_path__ + "static/media/data5.66de5492.jpg";